<template>
  <div class="category-label">
      <img v-if="chanelName === 'general'" :src="require('@/assets/Icons_Globe.png')" alt="">
      <img v-if="chanelName === 'language'" :src="require('@/assets/Icons_Language.png')" alt="">
      <img v-if="chanelName === 'mathematics'" :src="require('@/assets/Icons_Math.png')" alt="">
      <img v-if="chanelName === 'logic'" :src="require('@/assets/Icons_Puzzle.png')" alt="">

      <span>{{ name }}</span>
    </div>
</template>

<script>
export default {
  name: 'ChanelIcon',
  props: {
    chanelName: {
      type: String,
      required: true,
    },
  },
  computed: {
    name() {
      return this.chanelName.charAt(0).toUpperCase() + this.chanelName.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_breakpoints.scss";

.category-label {
  display: flex;
  align-items: center;
  img {
    background: #fff;
    width: 50px;
    height: 50px;
    border: 1px solid #000000;
    border-radius: 10px;
    display: block;
    margin-right: 10px;

    @include for-size(small-tablets-only-or-landscape) {
      display: none;
    }
  }
  span {
    color: #fff;
    font-size: 24px;
    font-weight: 600;

    @include for-size(small-tablets-only-or-landscape) {
      font-size: 20px;
    }
  }
}
</style>
